module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Basel-Stadt_matt-ad1291bc60fe1c5ea80491187e58a01f.svg";